<div class="label" [class.label--disabled]="disabled">{{ label }}</div>
<div class="right-container">
  <ng-content></ng-content>
</div>
